
<template>
  <!--会员信息-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="member_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <span>{{row.mobile_phone}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'member',
  data () {
    return {
      searchList: [
        { props: ['community_id'], placeholder: '小区', options: [], inputType: 'select' },
        { props: ['keywords'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['sex'], placeholder: '性别', options: this.$store.state.sexList, inputType: 'select' },
        { props: ['from_mode'], placeholder: '注册来源', options: [], inputType: 'select' },
        { props: ['from_os'], placeholder: '注册平台', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['is_bind_weixin'], placeholder: '微信绑定', options: this.$store.state.isBandList, inputType: 'select' },
        { props: ['register_date'], placeholder: ['注册时间', '注册时间'], options: [], inputType: 'datePick' },
        { props: ['login_date'], placeholder: ['最近登录时间', '最近登录时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        community_id: '',
        keywords: '',
        sex: '',
        from_mode: '',
        from_os: '',
        status: '',
        is_bind_weixin: '',
        register_date: '',
        login_date: ''
      },
      tableOptList: [],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.member_id), key: 'detail' },
        { text: '住房信息', handle: (row) => this.toHousingInfo(row.member_id), key: 'roomInfo' },
        { text: '', handle: (row) => this.switchStatus(row), customRender: true, key: 'status' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'member_id', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile_phone', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '性别', dataIndex: 'sex', align: 'left', width: '' },
        { title: '注册来源', dataIndex: 'from_mode', align: 'left', width: '' },
        { title: '注册平台', dataIndex: 'from_os', align: 'left', width: '' },
        { title: '注册时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '最近登录时间', dataIndex: 'last_login_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/member',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      let paramArr = [
        {index: 3, key: 'from_mode', scope: 'searchList'},
        {index: 4, key: 'from_os', scope: 'searchList'}
      ];
      this.memberManageSelect(paramArr);
    },
    /* 查看会员详情 */
    toDetail (id) {
      this.$router.push({
        name: 'memberDetail',
        query: { id: id }
      });
    },
    /* 查看住房信息 */
    toHousingInfo (id) {
      this.$router.push({
        name: 'housingInfo',
        query: { id: id }
      });
    },
    /* 切换会员状态 */
    switchStatus (row) {
      let newStaus = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/member/edit/${row.member_id}`,
        params: { status: newStaus }
      }).then((res) => {
        this.$message.success('状态切换成功！');
        this.$children[0].getTableList();
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/member/memberInfo/member.vue